import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Portofolio.css';

export default function OrquestadorMultiAgente() {
    return (
        <div className="portfolio-container">
            <Helmet>
                <title>Orquestador Multi-Agente (MAS) | Navi</title>
                <meta name="description"
                      content="Coordinación inteligente de agentes especialistas para el sector servicios y logística utilizando LangGraph y GPT-4o."/>
            </Helmet>

            {/* --- ENCABEZADO DEL PORTFOLIO --- */}
            <header className="portfolio-header">
                <span className="portfolio-category">SECTOR: SERVICIOS / LOGÍSTICA</span>
                <h1 className="portfolio-title">Orquestador Multi-Agente (MAS)</h1>
                <h2 className="portfolio-subtitle">
                    Coordinación inteligente de agentes especialistas. Gestionamos flujos de trabajo complejos donde
                    diferentes IAs colaboran para resolver problemas reales.
                </h2>
            </header>
            <div className="portfolio-hero-image">
                <img src="/imagenes_portofolio/Portofolio2_asset1.png" alt="Orquestamiento multi-agente"/>
            </div>
            {/* --- CONTENIDO --- */}
            <div className="portfolio-content">
                <p>
                    En sectores dinámicos como los servicios y la logística, un solo modelo de Inteligencia Artificial
                    (por muy avanzado que sea) a veces no es suficiente para resolver un proceso que involucra múltiples
                    departamentos. Es aquí donde entra en juego nuestra arquitectura MAS (Multi-Agent System).
                </p>

                <h3>El Enfoque: Especialización y Coordinación</h3>
                <p>
                    En lugar de tener un "super-agente" intentando hacer todo, implementamos una <strong>coordinación
                    inteligente de agentes especialistas</strong>. Cada agente tiene un rol definido, acceso a
                    herramientas específicas y un objetivo claro, operando bajo una arquitectura jerarquizada.
                </p>

                <h3>La Tecnología y el Stack</h3>
                <p>
                    Para gestionar estos flujos de trabajo complejos sin perder el control ni la trazabilidad,
                    utilizamos las herramientas más punteras del ecosistema de IA generativa:
                </p>
                <ul>
                    <li><strong>LangGraph:</strong> El núcleo de nuestro orquestador, permitiendo definir grafos
                        cíclicos donde los agentes pueden interactuar, debatir y corregirse.
                    </li>
                    <li><strong>GPT-4o:</strong> El motor de razonamiento principal detrás de la toma de decisiones de
                        los agentes.
                    </li>
                    <li><strong>Python & FastAPI:</strong> Para crear una API robusta y ultrarrápida que conecte el
                        orquestador con el resto de sistemas de la empresa.
                    </li>
                </ul>

                <h3>El Diferencial: Inteligencia Colaborativa</h3>
                <p>
                    Lo que realmente hace única a esta solución es cómo los agentes interactúan entre sí antes de
                    entregar un resultado al usuario final.
                </p>
                <blockquote className="portfolio-quote">
                    "Agentes con roles como Producción, Mantenimiento y Calidad colaboran, validan datos y debaten entre
                    sí para emitir una única respuesta final consolidada, precisa y validada."
                </blockquote>

                <h3>El Impacto</h3>
                <p>
                    Esta sinergia permite una automatización sin precedentes en áreas críticas como la <strong>atención
                    al cliente de alto nivel y la gestión de flotas</strong>. Las decisiones se toman con un
                    razonamiento natural, escalable y, sobre todo, auditable.
                </p>

                {/* --- GIF DEMOSTRATIVO --- */}
                <figure className="portfolio-image-wrapper">
                    {/* Reemplaza esta ruta con la de tu GIF real */}
                    <img src="/imagenes_portofolio/Portofolio2_asset2.gif"
                         alt="Flujo de trabajo de agentes en LangGraph"/>
                    <figcaption>Visualización del flujo de validación entre agentes especialistas.</figcaption>
                </figure>

                {/* --- CAJA DE LLAMADA A LA ACCIÓN (CTA) --- */}
                <div className="portfolio-cta-box">
                    <h3>¿Tus procesos requieren múltiples decisiones?</h3>
                    <p>Descubre cómo un equipo de agentes virtuales puede coordinar tu logística o atención al cliente
                        24/7.</p>

                    <button
                        className="cta-button"
                        onClick={() => window.open(
                            'https://wa.me/34624118531?text=%C2%A1Hola!%20Me%20interesa%20conocer%20m%C3%A1s%20sobre%20el%20Orquestador%20Multi-Agente.',
                            '_blank'
                        )}
                    >
                        Contactar con un experto en IA
                    </button>
                </div>
            </div>
        </div>
    );
}